import { render } from "./UserCarPolicy.vue?vue&type=template&id=49177878&scoped=true"
import script from "./UserCarPolicy.vue?vue&type=script&lang=ts"
export * from "./UserCarPolicy.vue?vue&type=script&lang=ts"

import "./UserCarPolicy.vue?vue&type=style&index=0&id=49177878&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-49177878"

export default script